import { Injectable } from '@angular/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { AppPermissionsService } from './permissions.service';
import { ITimeDuration } from '../../models/timer.model';
import { Store } from '@ngrx/store';
import { openQuestionnaireModal } from '../../store/actions/questions.actions';
import { PlatformService } from '../platform.service';

const NotificationTypes = {
  new_questions_ready: 'new_questions_ready',
};
@Injectable({
  providedIn: 'root',
})
export class LocalNotificationsService {
  constructor(
    private _permissions: AppPermissionsService,
    private store: Store,
    private _plt: PlatformService
  ) {}

  public async CheckNotificationPermissions() {
    try {
      const isWeb = this._plt.IsBrowser;
      if (isWeb) return;
      const { display } = await LocalNotifications.requestPermissions();
      if (display === 'denied') {
        this._permissions.PropmptOpenSettings();
      } else {
        this.setListeners();
      }
    } catch (error) {
      throw error;
    }
  }

  public setListeners() {
    LocalNotifications.removeAllListeners();
    const k = LocalNotifications.addListener(
      'localNotificationActionPerformed',
      (notif) => {
        console.log('notif 2', notif);
        if (
          notif.notification.actionTypeId ===
          NotificationTypes.new_questions_ready
        ) {
          this.store.dispatch(openQuestionnaireModal());
        }
      }
    );
  }

  showLocalNotification(title: string, body: string, at: Date): void {
    LocalNotifications.schedule({
      notifications: [
        {
          actionTypeId: NotificationTypes.new_questions_ready,
          title,
          body,
          id: this.getRandomArbitrary(0, 999999),
          schedule: {
            at,
          },
          smallIcon: 'res://ic_stat_notify.png',
          //   icon: 'res://icon.png',
          //   vibrate: true,
        },
      ],
    });
  }
  addHoursToCurrentDate(hours: number, minutes: number, seconds: number) {
    const currentDate = new Date();
    currentDate.setHours(currentDate.getHours() + hours);
    currentDate.setMinutes(currentDate.getMinutes() + minutes);
    currentDate.setSeconds(currentDate.getSeconds() + seconds);
    return currentDate;
  }

  public SendQuestionnairIsReadyNotification({
    hours,
    minutes,
    seconds,
  }: ITimeDuration) {
    console.log('-------SENDING SCHEDULED QUESTIONS ---------');
    const featdate = this.addHoursToCurrentDate(hours, minutes, seconds);
    console.log('featdate', featdate);
    this.showLocalNotification(
      'Save The World',
      "Τoday's questionnaire is ready",
      featdate
    );

    console.log('-------FINISH SCHEDULED QUESTIONS ---------');
  }

  public async SendTestNotification(seconds: number) {
    const perm = await LocalNotifications.requestPermissions();
    console.log('perm', perm);
    console.log('TIme now', new Date());
    const featdate = this.addHoursToCurrentDate(0, 0, seconds);
    console.log('TIme featdate', featdate);
    this.showLocalNotification(
      'Save The World',
      "Τoday's questionnaire is ready",
      featdate
    );
  }

  private getRandomArbitrary(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
